var map = {
	"./default.svg": "325b",
	"./folder.svg": "f6ca",
	"./html.svg": "18ea",
	"./mp4.svg": "1351",
	"./pdf.svg": "ff11",
	"./ppt.svg": "811e",
	"./txt.svg": "7967",
	"./zip.svg": "203a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2385";